/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import classNames from 'classnames';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

const uesStyles = makeStyles(
  () => ({
    layout: {
      marginTop: '48px',
      display: 'flex',
      justifyContent: 'center',
    },
    mb20: {
      marginBottom: '20px',
    },
    pd24: {
      padding: '24px',
    },
    h3: {
      fontSize: '20px',
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '32px',
    },
    h5: {
      fontSize: '14px',
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '22px',
    },
    body: {
      fontSize: '14px',
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '22px',
    },
    grid5: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
      gap: '12px',
      textAlign: 'center',
      padding: '24px 0',
    },
    gridTitle: {
      backgroundColor: '#fff',
    },
    bt: {
      borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    },
  }),
  { name: 'Listing-Box' },
);

function index() {
  const classes = uesStyles();

  return (
    <div className={classes.layout}>
      <div style={{ maxWidth: '1120px' }}>
        <div className={classNames(classes.h3, classes.mb20)}>What's the Difference?</div>
        <div>
          <div className={classNames(classes.grid5, classes.h3, classes.gridTitle)}>
            <div></div>
            <div>List</div>
            <div>Book</div>
            <div>
              <div>Connect</div>
              <div className={classes.body}>on Student.com Dashboard</div>
            </div>
            <div>
              <div>Connect</div>
              <div className={classes.body}>Direct to your PMS</div>
            </div>
          </div>
          <div className={classNames(classes.grid5, classes.bt)}>
            <div className={classes.h5}>Real-Time Inventory</div>
            <div>
              <CloseOutlined />
            </div>
            <div>
              <CloseOutlined />
            </div>
            <div>
              <CheckOutlined style={{ color: '#3BC56F' }} />
            </div>
            <div>
              <CheckOutlined style={{ color: '#3BC56F' }} />
            </div>
          </div>
          <div className={classNames(classes.grid5, classes.bt)}>
            <div className={classes.h5}>Student Pays to Confirm on Student.com</div>
            <div>
              <CloseOutlined />
            </div>
            <div>
              <div>
                <CheckOutlined style={{ color: '#3BC56F' }} />/
                <CloseOutlined />
              </div>
              <div>(Configurable)</div>
            </div>
            <div>
              <div>
                <CheckOutlined style={{ color: '#3BC56F' }} />/
                <CloseOutlined />
              </div>
              <div>(Configurable)</div>
            </div>
            <div>
              <div>
                <CheckOutlined style={{ color: '#3BC56F' }} />/
                <CloseOutlined />
              </div>
              <div>(Configurable)</div>
            </div>
          </div>
          <div className={classNames(classes.grid5, classes.bt)}>
            <div className={classes.h5}>Chat with Students via Student.com Dashboard</div>
            <div>
              <CloseOutlined />
            </div>
            <div>
              <CheckOutlined style={{ color: '#3BC56F' }} />
            </div>
            <div>
              <CheckOutlined style={{ color: '#3BC56F' }} />
            </div>
            <div>
              <CloseOutlined />
            </div>
          </div>
          <div className={classNames(classes.grid5, classes.bt)}>
            <div className={classes.h5}>Dashboard Usage</div>
            <div>View Leads</div>
            <div>Manage Leads (Accept / Reject / Counter Offer)</div>
            <div>Receive Confirmed Bookings on Student.com Dashboard</div>
            <div>Receive Confirmed Bookings Directly on your Property Management System</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
